import React from "react";

const WBCYearsContext = React.createContext(null);

export default WBCYearsContext;
